// src/lib/app-routes.ts

export type IconName = 
  | 'Home' 
  | 'BarChart2' 
  | 'Trophy' 
  | 'Route'
  | 'PackageMinus' 
  | 'Wrench' 
  | 'Car' 
  | 'Users' 
  | 'ShieldCheck' 
  | 'Settings'
  | 'UserIcon'
  | 'Building2'
  | 'RouteIcon'
  | 'TrafficCone'
  | 'Package'
  | 'ReceiptText'
  | 'PackageCheck'
  | 'Smile'
  | 'FileSearch'
  | 'Thermometer'
  | 'Banknote'
  | 'ShoppingBag'
  | 'ShieldAlert'
  | 'Truck'
  | 'RefreshCw'
  | 'Waves'
  | 'Printer';


export interface AppRoute {
  path: string;
  name: string;
  category: 'Gestão' | 'Motorista' | 'Geral' | 'Financeiro' | 'Expedição' | 'Loja' | 'RH';
  icon: IconName;
  hideFromNav?: boolean;
}

export const appRoutes: AppRoute[] = [
  // Gestão
  { path: "/dashboard", name: "Painel Principal", category: "Gestão", icon: "Home" },
  { path: "/dashboard/operations", name: "Operações", category: "Gestão", icon: "Route" },
  { path: "/dashboard/purchase-planning", name: "Planejamento de Compras", category: "Gestão", icon: "ShoppingBag" },
  { path: "/dashboard/analytics", name: "Análise Geral", category: "Gestão", icon: "BarChart2" },
  { path: "/dashboard/vehicle-analysis", name: "Análise por Veículo", category: "Gestão", icon: "Car" },
  { path: "/dashboard/deliveries", name: "Entregas", category: "Gestão", icon: "PackageCheck" },
  { path: "/dashboard/data-mapping", name: "Vínculos de Dados", category: "Gestão", icon: "PackageCheck", hideFromNav: true },
  { path: "/dashboard/demand-center", name: "Central de Demandas", category: "Gestão", icon: "FileSearch" },
  { path: "/dashboard/demand-center/customer-mapping", name: "Vínculo Cliente-Vendedor", category: "Gestão", icon: "Users", hideFromNav: true },
  { path: "/dashboard/ranking", name: "Ranking", category: "Gestão", icon: "Trophy" },
  { path: "/dashboard/roteiros", name: "Roteiros", category: "Gestão", icon: "RouteIcon" },
  { path: "/dashboard/returns-workflow", name: "Ocorrências", category: "Gestão", icon: "PackageMinus" },
  { path: "/dashboard/returns-v2", name: "Ocorrências (Lista)", category: "Gestão", icon: "PackageMinus" },
  { path: "/dashboard/damaged-salmon", name: "Controle de Salmão", category: "Gestão", icon: "Waves" },
  { path: "/dashboard/returns-ranking", name: "Ranking de Ocorrências", category: "Gestão", icon: "BarChart2", hideFromNav: true },
  { path: "/dashboard/lindemann-stock", name: "Estocagem Lindemann", category: "Gestão", icon: "Building2" },
  { path: "/dashboard/lindemann-stock/report", name: "Relatório Lindemann", category: "Gestão", icon: "BarChart2", hideFromNav: true },
  { path: "/dashboard/maintenance", name: "Manutenção", category: "Gestão", icon: "Wrench" },
  { path: "/dashboard/maintenance/calendar", name: "Calendário de Manutenção", category: "Gestão", icon: "Wrench", hideFromNav: true },
  { path: "/dashboard/fines", name: "Multas", category: "Gestão", icon: "TrafficCone" },
  { path: "/dashboard/temperatures", name: "Temperaturas", category: "Gestão", icon: "Thermometer" },
  { path: "/dashboard/vehicles", name: "Veículos", category: "Gestão", icon: "Car" },
  { path: "/dashboard/users", name: "Usuários", category: "Gestão", icon: "Users" },
  { path: "/dashboard/permissions", name: "Permissões", category: "Gestão", icon: "ShieldCheck" },
  { path: "/dashboard/settings", name: "Configurações", category: "Gestão", icon: "Settings" },
  { path: "/dashboard/sectors", name: "Setores", category: "Gestão", icon: "Building2" },
  
  // RH
  { path: "/dashboard/hr/ppe-delivery", name: "Entrega de EPI", category: "RH", icon: "ShieldAlert" },

  // Expedição
  { path: "/dashboard/invoice-conference", name: "Conferência de NF", category: "Expedição", icon: "PackageCheck" },
  { path: "/dashboard/invoice-conference/recalculate", name: "Recalcular Carga (Botão)", category: "Expedição", icon: "RefreshCw", hideFromNav: true },
  { path: "/dashboard/shipping/print-labels", name: "Impressão de Etiquetas", category: "Expedição", icon: "ReceiptText" },

  // Loja
  { path: "/dashboard/store/print-labels", name: "Etiquetas Loja", category: "Loja", icon: "Printer" },

  // Financeiro
  { path: "/dashboard/pouches", name: "Malotes", category: "Financeiro", icon: "Package" },
  { path: "/dashboard/invoices", name: "Gestão de NFs", category: "Financeiro", icon: "ReceiptText" },
  { path: "/dashboard/customers", name: "Clientes", category: "Financeiro", icon: "Users" },

  // Motorista
  { path: "/dashboard/driver", name: "Painel do Motorista", category: "Motorista", icon: "Home" },
  { path: "/dashboard/driver/my-vehicle", name: "Meu Veículo", category: "Motorista", icon: "Car" },
  { path: "/dashboard/driver/routes", name: "Meu Histórico", category: "Motorista", icon: "RouteIcon", hideFromNav: true },
  { path: "/dashboard/driver/returns", name: "Ocorrências/Devoluções", category: "Motorista", icon: "PackageMinus" },

  // Geral
  { path: "/dashboard/profile", name: "Meu Perfil", category: "Geral", icon: "UserIcon" },
];
